module.exports = __webpack_public_path__ + "img/card_one.11a11f46.png";